 import { 
  statusNewsStart,
  statusNewsSuccess,
  statusNewsFailure 
} from "./newsSlice";

import { getCustom, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getNewsApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusNewsStart())
    let response = await getCustom(`news`)
    const resData = response.data.success
    if(resData) {
      dispatch(statusNewsSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusNewsFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusNewsFailure(errData))
      return [errData]
    }
  }
}

export const AddNewApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusNewsStart())
    let response = await post(`news`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusNewsSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusNewsFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusNewsFailure(errData))
      return [errData]
    }
  }
}

export const EditNewApi = (newsId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusNewsStart())
    let response = await put(`news/${newsId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusNewsSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusNewsFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusNewsFailure(errData))
      return [errData]
    }
  }
}

export const DeleteNewApi = (newsId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusNewsStart())
    let response = await remove(`news/${newsId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusNewsSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusNewsFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusNewsFailure(errData))
      return [errData]
    }
  }
}

export const AddNewsPhotoApi = (newId: string = "", newData: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusNewsStart())
    const response = await post(`news/${newId}`, newData)
    const dataRes  = await response.data.success
    if(dataRes) {
      dispatch(statusNewsSuccess(dataRes))
      return true;
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusNewsFailure(formErrors))      
      return formErrors
    } else {
      dispatch(statusNewsFailure(errData.err))      
      return [errData.err]
    }
  }
}

export const DeleteNewsPhotoApi = (id: any, img: any = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusNewsStart());
    const response = await remove(`news/${id}/${img}`);
    const dataRes = response.data.success
    if(dataRes) {
      dispatch(statusNewsSuccess(dataRes))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusNewsFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusNewsFailure(errData.err))
      return errData.err
    }
  }
}

export const clearNewApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusNewsSuccess([]))
}
